import React, { useState, useEffect } from "react";
import { QRCodeSVG } from "qrcode.react";
import "./Clanarina.css";
import { useNavigate } from "react-router-dom";

const Clanarina = () => {
  const [isVisible, setIsVisible] = useState(false);
  const amount = 360;
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

    // ✅ Auth check on mount
  useEffect(() => {
    const isAuthenticated = sessionStorage.getItem("authenticated");
    if (isAuthenticated !== "true") {
      navigate("/Onas/Podstrani/Login");
    } else {
      setTimeout(() => {
        setIsVisible(true);
      }, 500);
    }
  }, [navigate]);

  useEffect(() => {
    setTimeout(() => {
      setIsVisible(true);
    }, 500);
  }, []);

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  };

  const calculateLength = (lines) => {
    return new TextEncoder().encode(lines.join("\n")).length;
  };

  const formatAmount = (eur) => {
    const cents = Math.round(eur * 100);
    return cents.toString().padStart(15, "0");
  };

  const dateStr = formatDate(new Date());

  const qrLines = [
    "UPNQR",
    "",
    "X",
    "",
    "",
    "",
    "",
    "",
    formatAmount(amount),
    dateStr,
    "X",
    "CHAR",
    "Članarina",
    dateStr,
    "SI56040010048731043",
    "SI00202504",
    "ROTARY CLUB ŽALEC",
    "Rimska cesta 98A",
    "3311 Šempeter v Savinjski dolini"
  ];

  const totalLength = calculateLength(qrLines);
  const upnQrValue = [...qrLines, totalLength.toString()].join("\n");

  const handleCustomJPGDownload = () => {
    const svg = document.getElementById("qrCode");
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.getElementById("qrCanvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();
    const svgBlob = new Blob([svgData], { type: "image/svg+xml;charset=utf-8" });
    const url = URL.createObjectURL(svgBlob);

    img.onload = () => {
      const width = 500;
      const height = 600;
      canvas.width = width;
      canvas.height = height;

      // White background
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, width, height);

      // Load and draw the Rotary logo
      const logo = new Image();
      logo.src = "/Slike/Rotary2.webp";

      logo.onload = () => {
        ctx.drawImage(logo, 0, 0, width, 120);

        // Draw QR Code
        ctx.drawImage(img, width / 2 - img.width / 2, 140);

        // Draw text
        ctx.fillStyle = "#000000";
        ctx.font = "20px Arial";
        ctx.textAlign = "center";
        ctx.fillText(`Plačilo Članarine ${currentYear}`, width / 2, 400);
        ctx.font = "16px Arial";
        ctx.fillText("Rotary Club Žalec", width / 2, 430);

        // Export to JPG
        const jpgDataUrl = canvas.toDataURL("image/jpeg", 1.0);
        const link = document.createElement("a");
        link.href = jpgDataUrl;
        link.download = "clanarina-qr.jpg";
        link.click();

        URL.revokeObjectURL(url);
      };
    };

    img.src = url;
  };

  return (
    <div className="membership-container">
      <div className={`membership-content ${isVisible ? "fade-in" : ""}`}>
        <img
          src="/Slike/Rotary2.webp"
          alt="Rotary Club Žalec"
          className="membership-logo"
        />

        <p className="membership-info">Plačilo Članarine za - {currentYear} 😉</p>

        <div className="membership-qr-section">
          <QRCodeSVG
            id="qrCode"
            value={upnQrValue}
            bgColor="#ffffff"
            fgColor="#000000"
            level="H"
            includeMargin={true}
          />
          <p className="membership-qr-text">Skenirajte QR kodo za plačilo članarine</p>

          <button onClick={handleCustomJPGDownload} className="memberdownload-button">
            Prenesi QR Kodo
          </button>

          <canvas id="qrCanvas" style={{ display: "none" }}></canvas>
        </div>

        <div className="membership-instructions">
          <p>1 - Odprite svojo mobilno banko (mBank - OTP Banka)</p>
          <p>2 - Skenirajte QR kodo</p>
          <p>3 - Potrdite plačilo</p>
        </div>
      </div>
    </div>
  );
};

export default Clanarina;